var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJishuiguan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_6359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0226 2.75562C10.9625 2.75562 7.70054 2.75562 5.44276 2.75562C4.04768 2.75562 2.91858 3.88655 2.91858 5.28163V5.28163C2.91858 6.67671 4.04952 7.80765 5.4446 7.80765H10.4966C11.8917 7.80765 13.0226 8.93859 13.0226 10.3337V10.3337C13.0226 11.7287 11.8917 12.8597 10.4966 12.8597H2.91858",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.22964,
    y: 10.3338,
    width: 0.459276,
    height: 5.05204,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.459276
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2522,
    y: 0.229638,
    width: 0.459276,
    height: 5.05204,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.459276
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4706 7.61536L5.47058 7.61536L6.47058 6.61536",
    stroke: "white",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_6359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJishuiguan);
export default __webpack_public_path__ + "static/media/jishuiguan.04369e1614e66bc1656f0b3737e8eb82.svg";
export { ForwardRef as ReactComponent };